<template>
  <div
    class="flex flex-col lg:grid lg:grid-cols-12 lg:centered-container lg:content-width pt-24 pb-12 md:py-8"
  >
    <div class="lg:col-start-2 lg:col-end-12 px-4 lg:px-0">
      <slot />
    </div>
  </div>
</template>
